const ValidationHelper = {
  /**
   * Validates a Brazilian CPF (Individual Taxpayer ID)
   */
  CPF: (cpf) => {
    const cleanCPF = cpf.replace(/\D/g, '');
    if (cleanCPF.length !== 11 || /^(\d)\1{10}$/.test(cleanCPF)) return false;

    const digits = cleanCPF.split('').map(Number);
    const calculateCheckDigit = (factor) => {
      let sum = 0;
      for (let i = 0; i < factor - 1; i++) {
        sum += digits[i] * (factor - i);
      }
      const remainder = (sum * 10) % 11;
      return remainder >= 10 ? 0 : remainder;
    };

    return calculateCheckDigit(10) === digits[9] && calculateCheckDigit(11) === digits[10];
  },

  /**
   * Validates a Brazilian CNPJ (Corporate Taxpayer ID)
   * Note: Compatible with numeric and the new alphanumeric format starting 2026.
   */
  CNPJ: (cnpj) => {
    const cleanCNPJ = cnpj.replace(/\D/g, '');

    if (cleanCNPJ.length !== 14 || /^(\d)\1{13}$/.test(cleanCNPJ)) return false;

    const digits = cleanCNPJ.split('').map(Number);

    const calculateCheckDigit = (slice) => {
      let factor = slice.length - 7;
      let sum = 0;

      for (let i = slice.length; i >= 1; i--) {
        const n = slice[slice.length - i];
        sum += n * factor--;
        if (factor < 2) factor = 9;
      }

      const remainder = sum % 11;
      return remainder < 2 ? 0 : 11 - remainder;
    };

    const firstDigit = calculateCheckDigit(digits.slice(0, 12));
    const secondDigit = calculateCheckDigit(digits.slice(0, 13));

    return firstDigit === digits[12] && secondDigit === digits[13];
  },

  passport: (passport, country) => {
    
    const passportFormats = {
      
      US: /^[A-Z0-9]{9}$/,
      CA: /^[A-Z]{2}\d{6}$/,
      GB: /^\d{9}$/,
      FR: /^\d{2}[A-Z]{2}\d{5}$/,
      DE: /^[A-Z0-9]{9}$/,
      ES: /^[A-Z]{3}\d{6}$/,
      IT: /^[A-Z]{2}\d{7}$/,
      PT: /^[A-Z]\d{6}$/,
      IN: /^[A-Z]\d{7}$/,
      AU: /^[A-Z]\d{7}$/,
      RU: /^\d{9}$/,
      KR: /^[A-Z]\d{8}$/,

      // latam
      AR: /^[A-Z]{3}\d{6}$/,
      MX: /^[A-Z]\d{8}$/,
      BR: /^[A-Z]{2}\d{6}$/,
      CL: /^[A-Z]\d{7}$/,
      UY: /^[A-Z]{2}\d{6}$/,
      PY: /^[A-Z]\d{7}$/,
      BO: /^[A-Z]{2}\d{6}$/,
      PE: /^[A-Z]{2}\d{7}$/,
      CO: /^[A-Z]{2}\d{7}$/,
      VE: /^[A-Z]{2}\d{6}$/,
      EC: /^[A-Z]{2}\d{6}$/,
      CR: /^[A-Z]\d{8}$/,
      PA: /^[A-Z]\d{7}$/,
      GT: /^[A-Z]{2}\d{6}$/,
      HN: /^[A-Z]\d{7}$/,
      NI: /^[A-Z]\d{7}$/,
      SV: /^[A-Z]\d{7}$/,
      DO: /^[A-Z]{2}\d{6}$/,

      // Ásia
      CN: /^[EGP]\d{8}$/, 
      JP: /^[A-Z]{2}\d{7}$/,

      // África
      ZA: /^[A-Z0-9]{9}$/,
      NG: /^[A-Z]{2}\d{7}$/,
      EG: /^[A-Z]\d{8}$/,
      MA: /^[A-Z]{2}\d{6}$/,
      TN: /^[A-Z]{2}\d{6}$/,
      DZ: /^[A-Z]{2}\d{6}$/,
      KE: /^[A-Z]\d{7}$/,
      GH: /^[A-Z]\d{7}$/,
      UG: /^[A-Z]\d{7}$/,
      TZ: /^[A-Z]\d{7}$/,
      ET: /^[A-Z]\d{7}$/,
      RW: /^[A-Z]\d{7}$/,
      SN: /^[A-Z]{2}\d{6}$/,
      CI: /^[A-Z]{2}\d{6}$/,
      CM: /^[A-Z]{2}\d{6}$/,
      ZW: /^[A-Z]{2}\d{6}$/
    };

    const regex = passportFormats[country];

    if (!regex) return true; 

    return regex.test(passport.toUpperCase());
  }
};

export default ValidationHelper;